interface RadioOption {
  label: string;
  value: string;
}

interface RadioGroupProps {
  label: string;
  options: RadioOption[];
  selected: string;
  onChange: (value: string) => void;
  labelBg?: string;
}

export const RadioGroup: React.FC<RadioGroupProps> = ({
  label,
  options,
  selected,
  onChange,
  labelBg = "#26c6da",
}) => (
  <div className="d-flex align-items-center flex-wrap gap-4">
    <span
      style={{
        backgroundColor: labelBg,
        color: "#fff",
        fontWeight: 700,
        fontSize: 11,
        padding: "4px 10px",
        borderRadius: 4,
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </span>
    {options.map((opt) => (
      <label
        key={opt.value}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 3,
          cursor: "pointer",
          fontSize: 12,
          fontWeight: selected === opt.value ? 700 : 400,
        }}
      >
        <input
          type="radio"
          name={label}
          checked={selected === opt.value}
          onChange={() => onChange(opt.value)}
          style={{
            accentColor: "#1565c0",
            cursor: "pointer",
          }}
        />
        {opt.label}
      </label>
    ))}
  </div>
);
